import { Box, Flex } from '@chakra-ui/react'

import swoosh from '../assets/swoosh.png'
import { SetDocumentTitle } from '../components/DocumentTitle/SetDocumentTitle'
import { browserTabStaticPageTitles } from '../store/appStore/browserDocumentTitle/browserTabTitleSpec'

export const SplashPage = () => {
  return (
    <Flex h="calc(100vh)" justify="center" align="center">
      <SetDocumentTitle title={browserTabStaticPageTitles.signIn} />
      <Box as="img" height={82} width={82} src={swoosh} alt="Logo" />
    </Flex>
  )
}
